import useSessionStore from "@features/session/hooks/useSessionStore";
import { isWeb } from "@helpers/platform";
import { useDevice } from "@hooks/useDevice";
import type {
	BaseItemSchema,
	OriginalItemTypes,
	RenderableItemTypes,
} from "@memorang/types/src/session/new-session";
import { Box } from "@memorang/ui";
import { ConversationRenderer } from "@memorang/ui/src/components/ConversationRenderer";
import { Caption } from "react-native-paper";
import useAIFeedbackStore from "../../../hooks/useAIFeedbackStore";
import ItemWrapper from "../../ItemWrapper";
import Writing from "./variants/Writing";

type Props = {
	item: BaseItemSchema;
	toggleShowReadMore?: () => void;
	originalItemType: OriginalItemTypes;
	mappedItemType: RenderableItemTypes;
};

const WritingContainer = ({
	item,
	toggleShowReadMore,
	originalItemType,
	mappedItemType,
}: Props) => {
	const userResponse = useAIFeedbackStore((state) => state.userResponse);
	const currentUserResponse = userResponse?.[item.id!];
	const itemStates = useSessionStore((state) => state.itemStates);
	const itemState = itemStates?.get(item.id!);
	const { isMobile } = useDevice();

	const isAnswered = itemState?.answered;
	const setUserResponse = useAIFeedbackStore((state) => state.setUserResponse);
	const isStreaming = useAIFeedbackStore((state) => state.streaming);
	const handleChangeText = (value: string) => {
		setUserResponse(item.id!, value);
	};
	const discussion = item.content?.discussion;

	const messages = discussion?.map((item) => ({
		name: item.student.name,
		avatarUrl: item.student.avatar.url,
		content: item.post,
	}));
	const showConversationView = messages && messages?.length > 0;

	const instruction = item.content?.instruction;
	const hasStem = item.content?.stem;

	return (
		<ItemWrapper
			item={item}
			toggleShowReadMore={toggleShowReadMore}
			originalItemType={originalItemType}
			mappedItemType={mappedItemType}
			showInstructions
			instructions={hasStem ? instruction : undefined}
			footer={
				!(isWeb || isStreaming) && (
					<Writing
						value={currentUserResponse as string}
						onChangeText={handleChangeText}
						key={item.id}
					/>
				)
			}
		>
			<Box
				paddingHorizontal={isWeb && !isMobile ? 0 : 16}
				gap={16}
				paddingBottom={isWeb ? 0 : 100}
			>
				{showConversationView ? (
					<ConversationRenderer messages={messages} />
				) : null}
				{instruction && !hasStem && <Caption>{instruction}</Caption>}
				{isWeb && (
					<Writing
						value={currentUserResponse as string}
						onChangeText={handleChangeText}
						key={item.id}
						disabled={isAnswered}
						sections={item.metadata?.sections}
					/>
				)}
			</Box>
		</ItemWrapper>
	);
};

export default WritingContainer;
